/**
 * Copyright (c) 2023 - Fuxlabs Vietnam Limited
 *
 * @author  NNTruong / nhuttruong6496@gmail.com
 */
import React from 'react';
import { Box } from '@mui/material';
export default function Index({
  color,
  size,
  width = '24px',
  height = '24px',
  ...other
}) {
  return (
    <Box
      component="svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      {...other}
      color={color ? color : 'primaryText'}
    >
      <path
        d="M12.6775 19.957C12.9523 20.0209 12.9775 20.3807 12.7099 20.4699V20.4699L11.1299 20.9899C7.15985 22.2699 5.06985 21.1999 3.77985 17.2299L2.49985 13.2799C1.21985 9.30992 2.27985 7.20992 6.24985 5.92992L6.77385 5.75639C7.17671 5.62297 7.56878 6.02703 7.45438 6.43571C7.39768 6.63828 7.34314 6.84968 7.28985 7.06992L6.30985 11.2599C5.20985 15.9699 6.81985 18.5699 11.5299 19.6899L12.6775 19.957Z"
        fill="currentColor"
      />
      <path
        d="M17.1702 3.21001L15.5002 2.82001C12.1602 2.03001 10.1702 2.68001 9.00018 5.10001C8.70018 5.71001 8.46018 6.45001 8.26018 7.30001L7.28018 11.49C6.30018 15.67 7.59018 17.73 11.7602 18.72L13.4402 19.12C14.0202 19.26 14.5602 19.35 15.0602 19.39C18.1802 19.69 19.8402 18.23 20.6802 14.62L21.6602 10.44C22.6402 6.26001 21.3602 4.19001 17.1702 3.21001ZM15.2902 13.33C15.2002 13.67 14.9002 13.89 14.5602 13.89C14.5002 13.89 14.4402 13.88 14.3702 13.87L11.4602 13.13C11.0602 13.03 10.8202 12.62 10.9202 12.22C11.0202 11.82 11.4302 11.58 11.8302 11.68L14.7402 12.42C15.1502 12.52 15.3902 12.93 15.2902 13.33ZM18.2202 9.95001C18.1302 10.29 17.8302 10.51 17.4902 10.51C17.4302 10.51 17.3702 10.5 17.3002 10.49L12.4502 9.26001C12.0502 9.16001 11.8102 8.75001 11.9102 8.35001C12.0102 7.95001 12.4202 7.71001 12.8202 7.81001L17.6702 9.04001C18.0802 9.13001 18.3202 9.54001 18.2202 9.95001Z"
        fill="currentColor"
      />
    </Box>
  );
}
